module.exports = __webpack_public_path__ + "img/pfbank.79276fa4.png";